module.exports = __webpack_public_path__ + "img/img_body_biz_shinhan_bank_logo.5adb712c.png";